/** Ключи, по которым Umi решает, показывать маршрут или нет. */
export const ACCESS_KEYS = ['canAdmin'] as const;

export type AccessKey = (typeof ACCESS_KEYS)[number];

/** Список разрешённых значений либо '*' — без ограничений. */
export type Scope<T extends string = string> = '*' | T[];

/** Что открывает одно разрешение. */
export interface PermissionLayout {
  slug: string;
  /** Ключ локализации названия разрешения. */
  labelId: string;
  /**
   * Разделы меню. Путь совпадает сам с собой и со всем, что лежит внутри:
   * '/subject' открывает и сам раздел, и все его страницы.
   */
  menu: Scope;
  /** Идентификаторы фреймов рабочей области на странице приветствия. */
  welcomeFrames: Scope;
  grants: Scope<AccessKey>;
}

/** Итоговая раскладка по всем разрешениям пользователя. */
export type ResolvedLayout = Pick<PermissionLayout, 'menu' | 'welcomeFrames' | 'grants'>;
